import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import { useInteractiveDownloader } from '@/hooks/useInteractiveDownloader';
import { useResolvedAssets } from '@/state/workflow.state';
import { shareLinkUrl } from '@/utils/shareLinks';
import { isDownloadableToolResult, toDownloadableToolResult } from './ToolOutputDownload';
import type { MediaAsset, TextAsset } from '@/types/api/assets';

export function useToolOutputAssetActions({
  result,
  workflowName,
  name,
}: {
  result: MediaAsset | TextAsset;
  workflowName: string;
  name: string;
}) {
  const resolvedAssets = useResolvedAssets();
  const { downloadNamedAssetsWithProgress } = useInteractiveDownloader();
  const { copyToClipboard } = useCopyToClipboard({ trackingName: 'tool_output_copy_link' });
  const link = result.type === 'text' ? '' : shareLinkUrl(result, resolvedAssets);
  const canDownload = isDownloadableToolResult(result, resolvedAssets);

  const download = () => {
    void downloadNamedAssetsWithProgress({
      assets: [{ name, asset: toDownloadableToolResult(result) }],
      archiveName: workflowName,
    });
  };

  return { link, canDownload, download, copyLink: () => void copyToClipboard(link) };
}
